export const getRoleHome = (role) => {
  if (role === 'provider') return '/provider/dashboard';
  if (role === 'admin') return '/admin/dashboard';
  return '/dashboard';
};

export const resolvePostAuthDestination = (from, role) => {
  const fallback = getRoleHome(role);
  const target = typeof from === 'string' ? from : from?.pathname;

  if (!target || target === '/login' || target === '/register' || target === '/auth/onboarding') {
    return fallback;
  }

  const isProviderAppRoute = target === '/provider' || target.startsWith('/provider/');
  const isAdminAppRoute = target === '/admin' || target.startsWith('/admin/');

  if (role !== 'provider' && isProviderAppRoute) {
    return fallback;
  }

  if (role !== 'admin' && isAdminAppRoute) {
    return fallback;
  }

  return typeof from === 'string'
    ? from
    : `${from.pathname || ''}${from.search || ''}${from.hash || ''}` || fallback;
};
